module.exports = __webpack_public_path__ + "static/media/bankid-logo.f8324788.svg";